(function () {
	document.addEventListener("DOMContentLoaded", function () {
		let buttons = document.querySelectorAll(".wp-block-button");

        buttons.forEach(item => {
           
            let buttonLink = item.querySelector('.wp-block-button__link');

            if( buttonLink.classList.contains("has-background") ){
                let buttonClasses = buttonLink.classList;            

                // Loop through button classes and apply them to .wp-block-button container
                buttonClasses.forEach(buttonClass => {
                    if( buttonClass.includes("has-") ){
                        item.classList.add(buttonClass);
                    }
                    
                });
            }

        });
	});
})();
